module.exports = __webpack_public_path__ + "static/bohater_6-5cd808a9ee8b90bf65c54378fcbfaea5.png";